import React from 'react';

import { Partner } from 'src/reducers/partner/types';

import i18n from 'Utilities/i18n';

import { PARTNER_TYPES } from 'Constants/partnerTypes';

type Props = {
  partner: Partner;
  scopes: string[];
};

const getSharingKey = (partner: Partner): string => {
  switch (partner.type) {
    case PARTNER_TYPES.COMMERCIAL_API:
      return 'Partners.Commercialapi.youAreSharing';
    case PARTNER_TYPES.INBOUND:
      return 'Partners.Inbound.isSharing';
    case PARTNER_TYPES.INSULET:
      return 'Partners.insuletIsSharing';
    default:
      return 'PartnersGeneric.youAreSharingSpecific';
  }
};

const SharingDescription: React.FC<React.PropsWithChildren<Props>> = ({ scopes, partner }) => {
  if (scopes && scopes.length !== 0 && partner.type !== PARTNER_TYPES.COMMERCIAL_API) {
    return null;
  }

  return (
    <div id="main-description" className="pt-3">
      <span id="main-description-text" className="mb-3 text-black-50 d-block">
        {i18n.t(getSharingKey(partner), {
          partner: partner.name,
          partnerName: partner.name,
        })}
      </span>
    </div>
  );
};

export default SharingDescription;
